<template>
    <div class="manage-advantages-section">
        <PageFrameContainer>
            <div class="manage-advantages">
                <div class="manage-advantage" v-for="(i,index) in $t('pages.main.manageAdvantages')"
                                                  :key="index">
                    <img :src="require(`../../../assets/pages/main/manage-advantages/RKEY_${(index+1)}.svg`)" :alt="i.alt"/>
                    <h4>{{i.title}}</h4>
                    <p>{{i.text}}</p>
                </div>
            </div>
            <div class="download-btn">
                <DownloadButton> {{ $t("pages.pricing.info.downloadButtonDesc") }}</DownloadButton>
            </div>
        </PageFrameContainer>
    </div>

</template>

<script>
    import PageFrameContainer from "../../../components/PageFrameContainer";
    import DownloadButton from "../../../components/DownloadButton";

    export default {
        name: "ManageAdvantagesSection",
        components: {DownloadButton, PageFrameContainer}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    .manage-advantages-section {
        padding-top: 3em;
        padding-bottom: 3em;
        background: $primary100;
        color: $primaryText100;

        .download-btn {
            display: grid;
            justify-items: center;
            margin-top: 2.5rem;
        }
    }

    .manage-advantages {
        display: grid;
        grid-gap: 2em;
        font-weight: 300;
        line-height: 1.5rem;

        h4 {
            margin-block-start: 0;
            margin-block-end: 0;
            font-size: 1.4rem;
            font-weight: 300;
            min-height: 5em;
            text-align: center;
        }

        img {
            align-self: start;
            justify-self: center;
            height: 5em;
        }

        p {
            text-align: justify;
            align-self: start;
        }
    }

    .manage-advantage {
        display: grid;
        grid-gap: 1em;
        justify-items: center;
        align-items: start;
    }


    @media (max-width: 40em) {
        .manage-advantages {
            grid-template-columns: 1fr;
        }

        .manage-advantage {
            grid-template-rows: 5em 2.5em 1fr;

            img {
                max-width: 20em;
            }
        }
    }

    @media (min-width: 40em) and (max-width: 50em) {
        .manage-advantages {
            grid-template-columns: 1fr 1fr 1fr;
        }
        .manage-advantage {
            grid-template-rows: 5em 5em 1fr;

            img {
                max-width: 10em;
            }
        }
    }

    @media (min-width: 50em) {
        .manage-advantages {
            grid-template-columns: 1fr 1fr 1fr;
        }
        .manage-advantage {
            grid-template-rows: 5em 3em 1fr;

            img {
                max-width: 10em;
            }
        }
    }

</style>